export { Input } from './Input';
declare module '@mui/joy/Input' {
  interface InputPropsVariantOverrides {
    borderplain: true;
  }
}

export * from '@mui/joy/Input';

export { default as InputSubscription } from './InputSubscription';
